module.exports = __webpack_public_path__ + "img/no-modules.aed08928.png";